/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintReceiptDto
 */
export interface PrintReceiptDto {
    /**
     * 
     * @type {number}
     * @memberof PrintReceiptDto
     */
    placementId: number;
    /**
     * 
     * @type {number}
     * @memberof PrintReceiptDto
     */
    copies: number;
    /**
     * 
     * @type {string}
     * @memberof PrintReceiptDto
     */
    type: PrintReceiptDtoTypeEnum;
}


/**
 * @export
 */
export const PrintReceiptDtoTypeEnum = {
    SALES_RECEIPT: 'SALES_RECEIPT',
    PROFORMA_RECEIPT: 'PROFORMA_RECEIPT'
} as const;
export type PrintReceiptDtoTypeEnum = typeof PrintReceiptDtoTypeEnum[keyof typeof PrintReceiptDtoTypeEnum];


/**
 * Check if a given object implements the PrintReceiptDto interface.
 */
export function instanceOfPrintReceiptDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "placementId" in value;
    isInstance = isInstance && "copies" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function PrintReceiptDtoFromJSON(json: any): PrintReceiptDto {
    return PrintReceiptDtoFromJSONTyped(json, false);
}

export function PrintReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintReceiptDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'placementId': json['placementId'],
        'copies': json['copies'],
        'type': json['type'],
    };
}

export function PrintReceiptDtoToJSON(value?: PrintReceiptDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'placementId': value.placementId,
        'copies': value.copies,
        'type': value.type,
    };
}

